import clsx from 'clsx';
import type { ReactNode } from 'react';
import type { CommonProps } from '../types.js';

export interface UNSTABLE_ContainerProps extends CommonProps {
  /** The contents of the container. */
  children: ReactNode;
  /**
   * The type of the container.
   * @default 'padded'
   */
  type?: 'padded' | 'full-width' | 'fixed-width';
}

export function UNSTABLE_Container({
  children,
  UNSAFE_className,
  UNSAFE_style,
  type = 'padded',
  ...props
}: UNSTABLE_ContainerProps) {
  return (
    <div {...props} className={clsx('cim-container', UNSAFE_className)} style={UNSAFE_style} data-type={type}>
      {children}
    </div>
  );
}

UNSTABLE_Container.displayName = 'Container';
